import { ActionContext as ActionContextType } from '@console/dynamic-plugin-sdk/src/api/internal-types';

export { ActionMenuVariant } from '@console/dynamic-plugin-sdk/src/api/internal-types';

export type ActionContext = ActionContextType;
